var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[_vm.class_name,{athena_num:_vm.theme=='athena',big_num:_vm.$store.state.cartContentsCount>99}]},[_vm._v(_vm._s((this.$store.state.cartContentsCount>99?'99+':this.$store.state.cartContentsCount) || 0))])}
var staticRenderFns = []

export { render, staticRenderFns }